import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';

import swal, { SweetAlertOptions } from 'sweetalert2';
import { SwalComponent } from '@toverux/ngx-sweetalert2';

import { AlertService, AuthenticationService } from '../_services';
import { Globals } from '../_helpers';
import { HttpHeaders, HttpClient } from '@angular/common/http';


export class MyErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
}

interface Gender {
  value: string;
  viewValue: string;
}
interface Qualification {
  value: string;
  viewValue: string;
}

@Component({
    selector: 'student-login',
    templateUrl: './user-signup.component.html',
})

export class UserSignupComponent implements OnInit {

    @ViewChild('alertBrowser') private alertBrowser: SwalComponent;

    public alertOption: SweetAlertOptions = {};

    nameFormControl = new FormControl('', [ Validators.required,  ]);
    genderFormControl = new FormControl('', [ Validators.required,  ]);
    usernameFormControl = new FormControl('', [ Validators.required,  ]);
    birthdateFormControl = new FormControl('', [
        Validators.required,
        Validators.minLength(9),
    ]);      
    emailFormControl = new FormControl('', [
        Validators.required,
        Validators.pattern("[^ @]*@[^ @]*"),
    ]);
    mobileFormControl = new FormControl('', [
        Validators.required,
        //Validators.minLength(10),
        Validators.pattern("[0-9]{10}"),
    ]);      
    passwordFormControl = new FormControl('', [ Validators.required,  ]);
    qualiFormControl = new FormControl('', [ Validators.required,  ]);
    stateFormControl = new FormControl('', [ Validators.required,  ]);
    districtFormControl = new FormControl('', [ Validators.required,  ]);
       
  
    matcher = new MyErrorStateMatcher();

    loading = false;
    submitted = false;
    isErrorLogin = false;
    errorMsg: string;
    returnUrl: string;
    isShowPass = true;
    isReset = false;
    resetMsg: string;
    hide = true;
    minDate: Date;
    maxDate: Date;
    high_qual: [];
    states: [];
    cities: [];

    genders: Gender[] = [
        {value: '', viewValue: 'Please Select'},
        {value: '1', viewValue: 'Male'},
        {value: '2', viewValue: 'Female'},
        {value: '3', viewValue: 'Transgender'},
    ];
/*    high_qual: Qualification[] = [
        {value: '', viewValue: 'Please Select'},
    ];*/
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
        private alertService: AlertService,
        private globals: Globals,
        private spinner: NgxSpinnerService,
        private http: HttpClient

    ) { 
        const d = new Date();
        const currentYear = new Date().getFullYear();
        this.minDate = new Date(currentYear - 70, 0, 1);
        this.maxDate = new Date(currentYear - 12, d.getMonth(), d.getDate());
    }


    ngOnInit() {
        /* clear loaclStorege */
        localStorage.clear();
        sessionStorage.clear();
        this.authenticationService.logout();
        this.spinner.hide();        
        this.returnUrl = '/';
        this.getQualification();
        this.getState();
    }

/*    ngAfterViewInit() {
        this.detectBrowserSuport();
    }*/

    onSubmit() {        
        this.submitted = true;

        /* stop here if form is invalid */
        if (this.nameFormControl.value == '' || this.genderFormControl.value == '' || this.birthdateFormControl.value == '' || this.emailFormControl.value == '' || this.mobileFormControl.value == '' || this.usernameFormControl.value == '' || this.passwordFormControl.value == '' || this.qualiFormControl.value == '' || this.stateFormControl.value == '' || this.districtFormControl.value == '') {
            this.isErrorLogin = false;
            return false;
        }
        else {
            this.loading = true;
            this.spinner.show();
            this.authenticationService.register(this.globals.root_url,this.nameFormControl.value, this.genderFormControl.value, this.birthdateFormControl.value, this.qualiFormControl.value, this.emailFormControl.value, this.mobileFormControl.value, this.stateFormControl.value, this.districtFormControl.value, this.usernameFormControl.value, this.passwordFormControl.value)
                .pipe(first())
                .subscribe(
                    data => {
                        if (data.code == 1000) {                                                 
                            this.isErrorLogin = false;
                            var info = data;                          
                            //localStorage.setItem('userinfo_ps', JSON.stringify({ student_id: info.id_self_student, name: info.name, email: info.email, mobile: info.mobile,profile_pic: info.profile_pic, usertoken: info.usercode }));
                            this.router.navigateByUrl('/checkotp/'+ info.id_self_student +'/4');                                     
                        }
                        else {
                            this.isErrorLogin = true;
                            this.errorMsg = data.status;
                            this.loading = false;
                        }
                        this.spinner.hide();
                    },
                    error => {
                        this.isErrorLogin = true;
                        this.errorMsg = 'Invalid Data !!';
                        this.alertService.error(error);
                        this.loading = false;
                        this.spinner.hide();
                    }
                );
        }
    }
    public getQualification() {
        this.authenticationService.highestquali(this.globals.root_url)
          .pipe(first())
          .subscribe(
            data => {
              if (data.code == 1000) {
                    this.high_qual = data.high_qual;                                             
              }
              else{
                  this.high_qual = [];
              }
            }
          )
    }
    public getState() {
        this.authenticationService.states(this.globals.root_url)
          .pipe(first())
          .subscribe(
            data => {
              if (data.code == 1000) {
                    this.states = data.states;                                             
              }
              else{
                  this.states = [];
              }
            }
          )
    }
    public getCity() {
        this.authenticationService.cities(this.globals.root_url, this.stateFormControl.value)
          .pipe(first())
          .subscribe(
            data => {
              if (data.code == 1000) {
                    this.cities = data.cities;                                             
              }
              else{
                  this.cities = [];
              }
            }
          )
    }    
    private detectBrowserSuport() {
        let isSupport = true;
        let video = document.createElement('video');
        if (video.canPlayType('video/ogg; codecs="theora"') == "")
            isSupport = false;

        if (video.canPlayType('video/mp4; codecs="avc1.42E01E"') == "")
            isSupport = false;

        if (video.canPlayType('video/webm; codecs="vp8, vorbis"') == "")
            isSupport = false;

        if (video.canPlayType('video/webm; codecs="vp9"') == "")
            isSupport = false;

        const audio = document.createElement('audio');
        if (audio.canPlayType('audio/mpeg') == "")
            isSupport = false;

        if (audio.canPlayType('audio/wav') == "")
            isSupport = false;

        if (!isSupport) {
            this.alertBrowser.show();
            //alert('Your brawser is unsupported, please update your brawser.');
        }
        else {
            console.log('ok');
        }

    }

    showPass() {
        this.isShowPass = false;
    }
    onHome() {
        this.router.navigate(['/home'])
    }
    login() {
        this.router.navigate(['/dashboard'])
    }

}


